import { render, staticRenderFns } from "./make-up.vue?vue&type=template&id=12b2f245&scoped=true"
import script from "./make-up.vue?vue&type=script&lang=js"
export * from "./make-up.vue?vue&type=script&lang=js"
import style0 from "./make-up.vue?vue&type=style&index=0&id=12b2f245&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b2f245",
  null
  
)

export default component.exports